import { h, Component } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Common, NewCommon } from "./wrappers";

export default class SoccerTracker extends Component {
	render({ event, lastEventName = null, isMobile }) {
		if (lastEventName == null)
			lastEventName = event && event.misc && event.misc.tracker.name || '';
		if (!event.misc.info)
			return null;
		return <NewCommon event={event} isMobile={isMobile}>
			<div class={"field field-" + event.misc.info.field}>
				<div
					key="animation-container"
					class={`animation-container ${event.misc.tracker.name} ${event.misc.tracker.team}`}
				>
					<span class="gate-l" />
					<span class="gate-r" />
					{lastEventName === "Attack" || lastEventName === "DangerousAttack" ? (
						<div class="new-attack-div">
							<div class="new-attack-dir" />
						</div>
					) : null}
					{lastEventName === "BallSafe" ? <div class="ball-safe-div" /> : null}
					{lastEventName === "RedCard" || lastEventName === "YellowCard" ? (
						<div class="new-rotator">
							<div class="new-card" />
						</div>
					) : null}
					{lastEventName === "GoalkeeperSave" ? <div /> : null}
					{lastEventName === "Corner" ? (
						<div class="new-corner">
							<div class="new-ball" />
						</div>
					) : null}
					{lastEventName === "FreeKick" /* || lastEventName === 'GoalKick'*/
						? [
								<div key="FreeKick-ripple" class="new-ripple" />,
								<div key="FreeKick-arrow" class="new-arrow" />,
								<div key="FreeKick-ball" class="new-ball" />,
						  ]
						: null}
					{lastEventName === "Substitution" ? <div class="new-sub-cont" /> : null}
					{lastEventName === "ThrowIn" ? (
						<div class="new-throw-in">
							<div class="new-ball" />
						</div>
					) : null}
					{lastEventName === "Goal" ? (
						<div class="goal-animation-frame">
							<p class="new-goal-text">
								<h1 class="goal-text-title">Goal</h1>
								<span class="goal-sub-text">{event.teams[event.misc.tracker.team].name}</span>
							</p>
						</div>
					) : null}

					{lastEventName === "Offside"
						? [<div key="Offside-line" class="line" />, <div key="Offside-ball" class="ball" />]
						: null}
					{lastEventName === "Penalty"
						? [<div key="Penalty-arrow" class="arrow" />, <div key="Penalty-ball" class="ball" />]
						: null}
				</div>
			</div>
			<div class="tk-action-container pt-1">
				<div class="bg-gray-500-7 px-2 py-2 rounded flex space-between">
					<div class="">{lastEventName.replace(/[A-Z]/g, (letter, idx) => (idx == 0 ? letter : ` ${letter}`))}</div>
					<div
						style={{
							"border-right": `2px solid #${
								event.misc.info[`shirt${event.misc.tracker.team == "home" ? 1 : 2}_color`]
							}`,
							"padding-right": "5px",
						}}
					>
						{event.teams[event.misc.tracker.team].name}
					</div>
				</div>
			</div>
		</NewCommon>
	}
}
